import React from "react";
import { RiDoubleQuotesR } from "react-icons/ri";
import { Font } from "../../theme/Font";
import { styled } from "styled-components";
import { useSelector } from "react-redux";
import { Color } from "../../theme/Color";
import {
  Section120,
  SubTitle,
  TitleSection,
} from "../DesignComponent/DesignComponents";

const T_3 = () => {
  const data = useSelector(
    (state) => state?.landingPage?.data?.acf?.testimonials_version_1
  );

  const QuoteText = styled.p`
    font-size: 24px;
    @media (max-width: 767px) {
      font-size: 18px;
    }
  `;
  return (
    <>
      <Section120 className="testimonials-sec text-center">
        <div className="container">
          <div className="row mb-md-5 mb-4">
            <div className="col-12">
              <SubTitle className="sub-title mb-2">
                {data?.testimonials_headings?.text_before_title}
              </SubTitle>
              <TitleSection className="mb-3">
                {data?.testimonials_headings?.title}
              </TitleSection>
            </div>
          </div>
          <div className="position-relative flex-lg-row flex-column-reverse">
            <div className="col-lg-9 col-md-7 mx-lg-0 mx-auto">
              <div
                className="text-start p-md-5 p-4"
                style={{ background: "#F8F5F1" ,borderRadius:"23px",boxShadow:"7.17px 7.17px 16.72px rgba(0, 0, 0, 0.12)" }}
              >
                <div className="col-lg-7">
                  <div className="testimonial-content">
                    <RiDoubleQuotesR size={48} />
                    <QuoteText
                      className="mb-4"
                      style={{ fontFamily: Font.medium, color: Color.black }}
                    >
                      {data?.testimonial_content?.quote_text}
                    </QuoteText>
                    <img
                      className="mb-2"
                      src={data?.testimonial_content?.company_logo}
                      width={41}
                      alt={data?.testimonial_content?.company_name}
                    />
                    <p
                      className="company-name mb-2"
                      style={{ fontSize: "14px", fontFamily: Font.basel }}
                    >
                      {data?.testimonial_content?.company_name}
                    </p>
                    <div
                      className="company-description mb-4"
                      style={{
                        fontSize: "14px",
                        fontFamily: Font.basel,
                        color: Color.lighterGrey,
                      }}
                    >
                      {data?.testimonial_content?.company_description}
                    </div>
                    <div className="rating-sec d-flex align-items-center mb-4">
                      <img
                        src={data?.testimonial_content?.rating_image}
                        style={{ width: "120px", marginRight: "10px" }}
                        alt="rating star"
                      />
                      <div
                        className="rating-number"
                        style={{
                          fontSize: "14px",
                          fontFamily: Font.basel,
                        }}
                      >
                        5.0
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-7 d-lg-block d-none">
              <img
                className="testimonial-image position-absolute"
                src={data?.testimonial_content?.image}
                style={{ width: "450px", top: "10%", right: "0%",borderRadius:"11px",boxShadow:"0px 7.17px 16.72px rgba(0, 0, 0, 0.12)" }}
                alt={data?.testimonial_content?.company_name}
              />
            </div>
            <div className="col-lg-3 col-md-7 d-lg-none d-block p-0 mx-auto">
              <img
                className="testimonial-image mb-3"
                src={data?.testimonial_content?.image}
                style={{ width: "100%" }}
                alt={data?.testimonial_content?.company_name}
              />
            </div>
          </div>
        </div>
      </Section120>
    </>
  );
};

export default T_3;
